import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Button } from '@material-ui/core'
import DatePicker from '../../../../LaridaeApp/datepicker/container/DatePicker'
import { getCumplimientoCuposNominables, getCumplimientoCuposVigentes, getCumplimientoCuposAsignados } from '../actions/TablaCumplimientoDeCuposActions'
import TablaCumplimientoDeCuposExportador from '../components/TablaCumplimientoDeCuposExportador'
import TablaCumplimientoDeCuposNominables from '../components/TablaCumplimientoDeCuposNominables'
import { COLORES } from '../../../../../config/colores'
import moment from 'moment'

function TablaCumplimientoDeCupos (props) {
  const { getCumplimientoCuposVigentes, getCumplimientoCuposNominables, getCumplimientoCuposAsignados, roles } = props
  const [showButton, setShowButton] = useState(false)
  const [fechaDesde, setFechaDesde] = useState(moment(new Date()).subtract(5, 'days').format('DD-MM-YYYY'))
  const [fechaHasta, setFechaHasta] = useState(moment(new Date()).format('DD-MM-YYYY'))

  useEffect(() => {
    getCumplimientoCuposVigentes(roles)
    getCumplimientoCuposNominables(roles, new Date(), new Date())
  }, [getCumplimientoCuposVigentes, getCumplimientoCuposNominables, roles])

  const actualizarFechas = (fechaD, fechaH) => {
    getCumplimientoCuposNominables(roles, fechaD, fechaH)
  }

  const actualizarFechasAsignados = (fechaD, fechaH) => {
    getCumplimientoCuposAsignados(roles, fechaD, fechaH)
    setShowButton(true)
    setFechaDesde(moment(fechaD).format('DD-MM-YYYY'))
    setFechaHasta(moment(fechaH).format('DD-MM-YYYY'))
  }

  const actualizarVigentes = () => {
    setFechaDesde(moment(new Date()).subtract(5, 'days').format('DD-MM-YYYY'))
    setFechaHasta(moment(new Date()).format('DD-MM-YYYY'))
    getCumplimientoCuposVigentes(roles)
    setShowButton(false)
  }

  return (
    <>
      <h3 style={{ marginTop: '-3%' }}>Cumplimiento de cupos</h3>

      <div className='container-entre-fechas'>
        <DatePicker
          selectRange
          disabledFuture
          locale='es'
          onDateChange={actualizarFechasAsignados}
          titulo='Seleccione las fechas'
          fechaDesde={fechaDesde || null}
          fechaHasta={fechaHasta || null}
        />
      </div>

      {showButton &&
        <Button
          style={{ backgroundColor: COLORES.grey.dark, color: 'white' }}
          onClick={actualizarVigentes}
        >
          Ver cupos vigentes
        </Button>
      }

      <TablaCumplimientoDeCuposExportador />

      <br />

      <div className='container-entre-fechas'>
        <DatePicker
          selectRange
          locale='es'
          onDateChange={actualizarFechas}
          titulo='Seleccione las fechas'
          value='fechas'
        />
      </div>

      <TablaCumplimientoDeCuposNominables />

    </>
  )
}

const mapStateToProps = (state) => {
  return {
    roles: state.auth.roles
  }
}

const mapActionsToProps = {
  getCumplimientoCuposAsignados,
  getCumplimientoCuposVigentes,
  getCumplimientoCuposNominables
}

const withRedux = connect(mapStateToProps, mapActionsToProps)
export default withRedux((TablaCumplimientoDeCupos))
